<script>
    export default {
        data() {
            return {
                state: Number,
                checkBox: HTMLElement,
            }
        },
        props: {
            checkboxValue: String,
            checkboxID: String,
            removeFilter: Array,
            addFilter: Array,
            clickMethod: Function,
        },
        watch: {
            addFilter() {
                this.checkState();
            },
            removeFilter() {
                this.checkState();
            }
        },
        async mounted() {
            this.checkBox = document.getElementById(this.checkboxID);
            if (this.addFilter.includes(this.checkboxValue) === true) {
                this.state = 1;
                this.checkBox.checked = true;
                return;
            }
            if (this.removeFilter.includes(this.checkboxValue) === true) {
                this.state = 2;
                this.checkBox.indeterminate = true;
                return;
            }
            this.state = 0;
            this.checkBox.checked = false;
        },
        methods: {
            checkState() {
                if (
                    this.addFilter.length === 0 &&
                    this.removeFilter.length === 0
                ) {
                    this.state = 0;
                    this.checkBox.checked = false;
                    this.checkBox.indeterminate = false;
                }
            },
            async updateState(event) {
                switch (this.state) {
                    case 0:
                        this.clickMethod(true, this.checkboxValue, true);
                        this.checkBox.checked = true;
                        this.state = 1;
                    break;
                    case 1:
                        this.clickMethod(false, this.checkboxValue, true);
                        this.clickMethod(true, this.checkboxValue, false);
                        this.checkBox.indeterminate = true;
                        this.state = 2;
                    break;
                    case 2:
                        this.clickMethod(false, this.checkboxValue, false);
                        this.checkBox.checked = false;
                        this.state = 0;
                    break
                }
            }
        }
    }
</script>

<template>
    <input 
        type="checkbox"
        :id="checkboxID"
        :value="checkboxValue"
        @change="updateState($event)"
    >
</template>